import React, { useEffect, useState, useRef } from 'react';
import { Table, Input, Form, Col, Row, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
// import { PlusOutlined } from '@ant-design/icons';
// import { ReactComponent as EditIcon } from '../../assets/edit-icon.svg';
// import { ReactComponent as DeleteIcon } from '../../assets/delete-icon.svg';
// import { ReactComponent as SaveIcon } from '../../assets/save-icon.svg';
// import { ReactComponent as CrossIcon } from '../../assets/cross-icon.svg';
// import SpinnerComponent from '../../components/spinner';
import { arrayMoveImmutable } from 'array-move';
import DragDropIcon from '../../assets/dragdropicon.png';
import {
  createCoachTypes,
  deleteCoachTypes,
  fetchCoachTypes,
  isAddingAction,
  updateCoachTypesOrder,
  updateCoachTypes,
} from './redux/actions';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';

const SortableItem = SortableElement((props) => <tr {...props} />);
const SortableBody = SortableContainer((props) => <tbody {...props} />);
const DragHandle = SortableHandle(() => <img alt='' src={DragDropIcon} />);

const CoachTypesTable = ({ canUpdate }) => {
  const [editingLoading, setEditingLoading] = useState(false);
  const [editingKey, setEditingKey] = useState('');
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const ref = useRef();
  const isEditing = (record) => record.id === editingKey;

  const { allCoachTypes, fetchingLoading, updateLoading, isAdding } =
    useSelector((state) => state.coachTypesReducer);

  useEffect(() => {
    dispatch(fetchCoachTypes());

    return () => {
      dispatch(isAddingAction(false));
    };
  }, []);

  useEffect(() => {
    setEditingLoading(updateLoading);
    if (!updateLoading) {
      setEditingKey('');
    }
  }, [updateLoading]);

  useEffect(() => {
    setData(allCoachTypes);
  }, [allCoachTypes]);

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const textInput = (
      <Input
        placeholder='Insert Type Name'
        ref={ref}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            save(record.id);
          }
        }}
      />
    );

    let inputNode = null;

    if (dataIndex === 'name') {
      return (
        <td {...restProps}>
          {editing ? (
            <Form.Item
              name={dataIndex}
              style={{
                margin: 0,
              }}
              rules={[
                {
                  required: true,
                  message: `This field is required!`,
                },
                {
                  min: 1,
                  message: `invalid!`,
                },
              ]}
            >
              {textInput}
            </Form.Item>
          ) : (
            children
          )}
        </td>
      );
    }
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            // valuePropName={
            //   dataIndex === 'show_by_default' ? 'checked' : 'value'
            // }
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Required!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const edit = (record) => {
    dispatch(isAddingAction(true));

    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.id);
    setTimeout(() => {
      ref.current?.focus();
    }, 300);
  };

  const cancel = (record) => {
    dispatch(isAddingAction(false));
    form.resetFields();
    setEditingKey('');
    if (record?.isAdd) {
      return setData((data) => data.filter((el) => el.id !== record.id));
    } else {
      setData(data);
    }
  };

  const save = async (id) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => id === item.id);
      if (index > -1) {
        const item = newData[index];
        if (item?.isAdd) {
          form.submit();
        } else {
          if (isAlreadyExist({ ...item, ...row })) {
            return message.error('Type name already exist!');
          }

          dispatch(
            updateCoachTypes({
              ...item,
              ...row,
            })
          );
        }
      }
    } catch (errInfo) {
      if (errInfo?.values?.name === '') {
        message.error('Type Name should not be blank!');
      }
    }
  };

  const handleDelete = (record) => {
    setEditingKey(record.id);
    dispatch(deleteCoachTypes(record));
  };

  const handleAdd = () => {
    dispatch(isAddingAction(true));
    let id = Math.floor(Math.random() * 1122123456);
    const newData = {
      id,
      name: '',
      isAdd: true,
    };
    setData((data) => [...data, newData]);
    setEditingKey(id);
    edit(newData);
  };

  const isAlreadyExist = (record) => {
    const { name } = record;
    const alreadyExist = data.filter(
      (el) => el.name?.trim()?.toLowerCase() === name?.trim()?.toLowerCase()
    );

    return alreadyExist.length > 0 && record.id !== alreadyExist[0]?.id
      ? true
      : false;
  };

  const hanldeFinish = (values) => {
    const { name } = values;

    if (isAlreadyExist(values)) {
      return message.error('Type name already exist!');
    }

    dispatch(
      createCoachTypes({
        name: name.trim(),
        id: editingKey,
        type_for: 'coach',
      })
    );
  };

  const columns = [
    {
      title: 'Type Name',
      dataIndex: 'name',
      key: 'name',
      width: '60%',
      editable: true,
    },
    // {
    //   title: '',
    //   key: 'action',
    //   dataIndex: '',
    //   width: '25%',
    //   align: 'left',
    //   render: (_, record) => {
    //     if (!canUpdate) {
    //       return;
    //     }

    //     const { status_type } = record;
    //     let canDelete = status_type === 'not-selected' ? false : true;

    //     const editable = isEditing(record);
    //     return editable ? (
    //       editingLoading && editingKey === record.id ? (
    //         <SpinnerComponent fontSize={14} />
    //       ) : (
    //         <Space size={20} align='center'>
    //           <SaveIcon
    //             className='custom-icon'
    //             onClick={() => save(record.id)}
    //           />
    //           <Popconfirm
    //             title='Sure to cancel?'
    //             onConfirm={() => cancel(record)}
    //           >
    //             <CrossIcon
    //               style={{ height: '20px', width: '20px' }}
    //               className='custom-icon'
    //             />
    //           </Popconfirm>
    //         </Space>
    //       )
    //     ) : (
    //       <Space size={20} align='center'>
    //         <EditIcon
    //           className={`custom-icon ${isAdding ? 'disable-icon' : ''}`}
    //           disabled={editingKey !== ''}
    //           onClick={() => !isAdding && edit(record)}
    //         />
    //         {canDelete &&
    //           data.length >= 1 &&
    //           (isAdding ? (
    //             <DeleteIcon className={`custom-icon disable-icon`} />
    //           ) : (
    //             <Popconfirm
    //               title='Are you sure you want to delete this type?'
    //               onConfirm={() => handleDelete(record)}
    //               okText='Yes'
    //               cancelText='No'
    //             >
    //               <DeleteIcon className='custom-icon' />
    //             </Popconfirm>
    //           ))}
    //       </Space>
    //     );
    //   },
    // },
    {
      title: 'Order',
      dataIndex: 'order',
      key: 'order',
      width: '15%',
      className: 'drag-visible',
      render: (order, record) => {
        const { status_type } = record;
        let canDelete = status_type === 'not-selected' ? false : true;
        return !Boolean(editingKey) && canUpdate && canDelete && <DragHandle />;
      },
    },
  ];

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const { status_type } = data[newIndex];

    let shouldNotReorder = status_type !== 'not-selected' ? false : true;

    if (shouldNotReorder) {
      return setData((prevData) => prevData);
    }

    if (oldIndex !== newIndex) {
      const newData = arrayMoveImmutable(
        data.slice(),
        oldIndex,
        newIndex
      ).filter((el) => !!el);

      dispatch(updateCoachTypesOrder(newData));
    }
  };

  const DraggableContainer = (props) => (
    <SortableBody
      useDragHandle
      disableAutoscroll
      helperClass='row-dragging'
      onSortEnd={onSortEnd}
      {...props}
    />
  );

  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    const index = data.findIndex(
      (x) => x.position == restProps['data-row-key']
    );

    return <SortableItem index={index} {...restProps} />;
  };

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: 'text',
        dataIndex: col.dataIndex,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Row justify='center' className='production-manager-parent-row'>
      <Col xxl={24} xl={24} lg={24} md={24} className='heading-col'>
        <Row align='middle' gutter={[30, 0]}>
          <Col>
            <div>
              <span className='heading-span'>Coach Types</span>
            </div>
          </Col>
        </Row>
      </Col>

      <Col lg={23} xl={18} xxl={17} md={24} style={{ minHeight: '70vh' }}>
        <Form
          form={form}
          component={false}
          onFinish={hanldeFinish}
          className='table-style'
        >
          <Table
            className='special-table activity-type-table project-statuses-table'
            components={{
              body: {
                cell: EditableCell,
                wrapper: DraggableContainer,
                row: DraggableBodyRow,
              },
            }}
            scroll={{ x: !fetchingLoading }}
            rowClassName='editable-row'
            dataSource={data}
            loading={fetchingLoading}
            columns={mergedColumns}
            pagination={false}
            rowKey='position'
          />
          <br />
          {/* <Col offset={1} lg={24} xl={18} xxl={17} md={24} className='table'>
            {canUpdate && (
              <Button
                icon={<PlusOutlined />}
                className='add-status-btn add-couch-type-btn'
                size='middle'
                disabled={isAdding}
                onClick={handleAdd}
              >
                COACH TYPE
              </Button>
            )}
          </Col> */}
        </Form>
      </Col>
    </Row>
  );
};

export default CoachTypesTable;
